import { FC } from 'react';
import {
  StyledCurrentPrice,
  StyledPriceChangeContainer,
  StyledPriceChangePercent,
  StyledPriceChangeTag,
  StyledPriceChangeText,
  StyledPriceContainer,
} from '../styled';
import { AssetPriceProps } from '../types';

/**
 * Asset Price Component
 * Displays current price, price change tag, and percentage change
 */
export const AssetPrice: FC<AssetPriceProps> = ({
  formattedPrice,
  formattedChange,
  formattedPercent,
  changeColor,
}) => {
  return (
    <StyledPriceContainer>
      <StyledCurrentPrice>{formattedPrice}</StyledCurrentPrice>

      <StyledPriceChangeContainer>
        <StyledPriceChangeTag changeColor={changeColor}>
          <StyledPriceChangeText>{formattedChange}</StyledPriceChangeText>
        </StyledPriceChangeTag>
        <StyledPriceChangePercent>{formattedPercent}</StyledPriceChangePercent>
      </StyledPriceChangeContainer>
    </StyledPriceContainer>
  );
};
